import { motion } from "framer-motion";
import styled, { css } from "styled-components";

import type { ColorName } from "styles/config/colors";
import themeColors from "styles/config/colors";
import sizes from "styles/config/sizes";

export const Sidebar = styled(motion.div)<{
  $paddingTop?: number;
  $position: "left" | "right";
  $isMainNavOpen?: boolean;
  $backgroundColor?: ColorName;
  $maxWidth?: number;
}>`
  position: fixed;
  top: 0;

  flex-shrink: 0;

  width: fill-available;
  height: 100dvh;
  padding-top: ${({ $paddingTop }) => $paddingTop}px;

  background-color: ${({ $backgroundColor = "background" }) =>
    themeColors[$backgroundColor]};
  box-shadow: ${({ $position }) => ($position === "right" ? "-" : "")}2px 0 10px
    0 ${themeColors.shadow};

  ${({ $isMainNavOpen }) =>
    $isMainNavOpen
      ? css`
          max-width: calc(100% - ${sizes.mainNavWidth}px);
        `
      : css`
          max-width: 100%;
        `};
  transition: max-width 0.2s ease-in-out, padding 0.2s ease-in-out;

  ${({ $position }) => ($position === "left" ? "left: 0;" : "right: 0;")}
  ${({ $maxWidth }) =>
    $maxWidth ? `max-width: ${$maxWidth}px` : `max-width: none`}
`;

export const Overlay = styled.div<{
  $open: boolean;
  $excludeRightPanelWidth?: number;
}>`
  pointer-events: none;

  position: fixed;
  z-index: 30;
  inset: 0 0 0 100%;

  background-color: transparent;

  transition: background-color 0.2s ease-in-out;

  ${({ $open, $excludeRightPanelWidth }) =>
    $open &&
    css`
      pointer-events: all;
      inset: 0 ${$excludeRightPanelWidth ? `${$excludeRightPanelWidth}px` : 0} 0
        0;
      background-color: ${themeColors.backgroundOverlay};
    `}
`;

export const FakeSidebar = styled(motion.div)`
  flex-shrink: 0;
`;

export const SidebarStickyHeader = styled.div<{
  $backgroundColor?: ColorName;
  $borderColor?: ColorName;
}>`
  position: sticky;
  z-index: 15;
  top: 0;

  background: ${({ $backgroundColor = "background" }) =>
    themeColors[$backgroundColor]};
  border-bottom: 1px solid
    ${({ $borderColor = "borderSubtle" }) => themeColors[$borderColor]};
`;

export const SidebarStickyFooter = styled.div<{
  $backgroundColor?: ColorName;
  $borderColor?: ColorName;
}>`
  position: sticky;
  z-index: 15;
  bottom: 0;

  background: ${({ $backgroundColor = "background" }) =>
    themeColors[$backgroundColor]};
  border-bottom: 1px solid
    ${({ $borderColor = "borderSubtle" }) => themeColors[$borderColor]};
`;

export const SidebarScrollableContent = styled.div<{
  $hideScrollbar?: boolean;
  $flex?: boolean;
}>`
  position: relative;
  overflow: clip auto;
  overscroll-behavior: none;
  height: 100%;

  ${({ $hideScrollbar }) =>
    $hideScrollbar &&
    css`
      scrollbar-width: none;

      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `}

  ${({ $flex }) =>
    $flex &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;

export const Fader = styled(motion.div)<{ position: "top" | "bottom" }>`
  ${({ position }) => (position === "top" ? "top" : "bottom")}: 0;

  pointer-events: none;

  position: fixed;
  z-index: 11;

  height: 80px;

  background: linear-gradient(
    rgb(247, 247, 252, ${({ position }) => (position === "top" ? 1 : 0)}),
    rgb(247, 247, 252, ${({ position }) => (position === "bottom" ? 1 : 0)})
  );
`;
